import { Component, OnInit, ViewChild, ElementRef, Output, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { UserTypeManagerService, UserType } from "../services/usertype/user-type-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";
import { LogService } from "../services/log/log.service";

// import { Inject } from '@angular/core';
// import { DOCUMENT } from '@angular/platform-browser';

import 'codemirror/mode/css/css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/clike/clike';
import 'codemirror/mode/django/django';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/http/http';
import 'codemirror/mode/perl/perl';
import 'codemirror/mode/php/php';
import 'codemirror/mode/python/python';
import 'codemirror/mode/ruby/ruby';
import 'codemirror/mode/sql/sql';
import 'codemirror/mode/swift/swift';
import 'codemirror/mode/xml/xml';


import * as codemirror from 'codemirror'

declare var CodeMirror;
declare var $

@Component({
    selector: "dskl-wb-code",
    templateUrl: 'code-wb.component.html',
    inputs: ["board"],
    outputs: ["change", "onCurrentState"],

})

export class CodeWbComponent extends WhiteBoardComponent {

    constructor(private log: LogService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, private userTypeManager: UserTypeManagerService, protected layoutService: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
        super(log, wbService, sessionManager, layoutService, permissionsManager);
        console.log('..constructing CODE')
    }

    @ViewChild('code') codeElement: ElementRef;
    editor: any;
    pageName = "CODE"
    intialTextValue = "package eu.daskal.wb;\npublic class CodeDeskExample {\n  public static void main(String[] args) {\n      System.out.println(\"Hello, world!\");\n    }\n}"
    stateStorage = {
        language: "text/x-java",
        theme: "dracula",
        state: undefined
    };

    onViewReady() {
        let that = this;
        this.editor = CodeMirror.fromTextArea(
            that.codeElement.nativeElement,
            {
                lineNumbers: true,
                theme: that.stateStorage.theme,
                mode: that.stateStorage.language,
            })
        this.editor.setSize('100%', '100%');
        this.editor.getDoc().setValue(this.intialTextValue);
        this.editor.on('keyup', (data) => {
            this.stateStorage.state = this.getEditorContentStructure()
            this.emitChanged(this.stateStorage);
        })
        this.editor.on('inputRead', (data) => {
            this.stateStorage.state = this.getEditorContentStructure()
            this.emitChanged(this.stateStorage);
        })
        this.setStateStorageInitialValues()   //initial so we dont polute DB with 'undefined'

    }

    private setStateStorageInitialValues() {
        this.stateStorage.state = this.getEditorContentStructure();
    }

    setLanguage(language, notifyServer) {
        if (language != this.stateStorage.language) {
            this.stateStorage.language = language;
            this.editor.setOption("mode", language);
            if (notifyServer) {
                this.emitChanged(this.stateStorage)
            }

        }

    }

    setTheme(theme, notifyServer) {
        if (theme != this.stateStorage.theme) {
            this.stateStorage.theme = theme;
            this.editor.setOption("theme", theme);
            if (notifyServer) {
                this.emitChanged(this.stateStorage)
            }
        }
    }

    getCurrentState() {
        var response = this.stateStorage
        return this.stateStorage;
    }

    private getEditorContentStructure() {
        var $$ = this,
            doc = $$.editor.getDoc(),
            marks = doc.getAllMarks(),
            res = {
                value: $$.editor.getValue(),
                selections: doc.listSelections(),
                marks: []
            };
        if (marks.length) {
            // We reverse the array in order to start in the last folded parts in case of nesting
            for (var i = marks.length - 1; i >= 0; i--) {
                if (marks[i].collapsed && (marks[i].type === 'range')) {
                    res.marks.push(marks[i].find().from);
                }
            }
        }
        return res;
    }

    private setScreenFromObject(stateObject) {
        if (stateObject.language != this.stateStorage.language) {
            this.setLanguage(stateObject.language, false);
        }
        if (stateObject.theme != this.stateStorage.theme) {
            this.setTheme(stateObject.theme, false);
        }
        if (stateObject.state != this.stateStorage.state) {
            let state = stateObject.state
            var $$ = this,
                doc = $$.editor.getDoc();
            if (state.value !== undefined) {
                $$.editor.setValue(state.value);
            }
            if (state.selections) {
                $.each(state.selections, function (i, a) {
                    doc.setSelection(a.anchor, a.head);
                })
            }
            if (state.marks) {
                $.each(state.marks, function (i, a) {
                    $$.editor.foldCode(a);
                });
            }
            this.stateStorage.state = this.getEditorContentStructure()

        }
    }

    onState(stateObject, pageId) {
        console.log(stateObject)
        if (pageId != this.board.pageId) {
            console.log("Not for me " + this.board.pageId + " but for " + pageId);
            console.log(stateObject);
            return;
        }
        this.setScreenFromObject(stateObject)
    }
    onResize() {
        var height = this.getResizeTopOffset();
        var footerHeight = $("footer").height()
        height += footerHeight
        var h = window.innerHeight - height -10;
        var paramHeight = h + "px"
        $("#code-screen").css("height", h);
        console.log("Code board will resize to ", h)
        this.editor.setSize("100%", paramHeight)
    }
    onCurrentPageState(stateObject, pageId) {
        if (!stateObject || pageId != this.board.pageId) {
            return
        }
        this.setScreenFromObject(stateObject)

    }

    onReady() {


    }

    getWbType() {
        return this.pageName;
    }



}



// WEBPACK FOOTER //
// /app/src/app/wb/code/code-wb.component.ts